import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUnreadCount } from '../features/notifications/notificationsSlice';
import { registerWebPush } from '../utils/webPush';

/**
 * After login / session restore: request notification permission and
 * register the FCM web token with POST /device-tokens.
 * Foreground pushes refresh the in-app unread badge.
 */
const WebPushRegistrar = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.token);
  const user = useSelector((state) => state.auth?.user);
  const verificationRequired = useSelector((state) => state.auth?.verificationRequired);
  const startedForUserRef = useRef(null);

  useEffect(() => {
    const authToken = token || localStorage.getItem('auth_token');
    if (!authToken || !user || verificationRequired) {
      startedForUserRef.current = null;
      return undefined;
    }

    const userKey = String(user.id ?? user.user_id ?? user.email ?? '');
    if (!userKey || startedForUserRef.current === userKey) {
      return undefined;
    }
    startedForUserRef.current = userKey;

    let cancelled = false;

    (async () => {
      if (cancelled) return;
      await registerWebPush({
        onForegroundMessage: () => {
          dispatch(fetchUnreadCount());
        },
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, token, user, verificationRequired]);

  return null;
};

export default WebPushRegistrar;
